import { Transform, Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  Matches,
  Min,
  ValidateNested,
} from 'class-validator';
import { CompleteReceiptLotAllergenDto } from './complete-receipt.dto';

export class UpdateDeliveryItemDto {
  @IsString()
  @IsNotEmpty()
  @IsOptional()
  productName?: string;

  @IsNumber()
  @Min(0)
  @IsOptional()
  @Transform(({ value }: { value: unknown }) =>
    value === '' || value === null ? undefined : Number(value),
  )
  quantity?: number;

  @IsString()
  @IsOptional()
  unit?: string;

  @IsString()
  @IsOptional()
  batchNumber?: string | null;

  @IsString()
  @IsOptional()
  expiryDate?: string | null;

  /** Mutually exclusive with expiryDate (XOR enforced server-side). */
  @IsBoolean()
  @IsOptional()
  hasNoExpiry?: boolean;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CompleteReceiptLotAllergenDto)
  allergens?: CompleteReceiptLotAllergenDto[];

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Transform(({ value }: { value: unknown }) =>
    value === '' || value === null ? undefined : Number(value),
  )
  unitPrice?: number;

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Transform(({ value }: { value: unknown }) =>
    value === '' || value === null ? undefined : Number(value),
  )
  lineTotal?: number;

  @IsOptional()
  @IsString()
  @Matches(/^[A-Z]{3}$/)
  currency?: string;
}
